import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  display: flex;
  flex-direction: row;

  > div {
    &:first-child {
      flex: 1 0 auto;
      padding-left: 17px;
      padding-right: 47px;
      border-right: 1px solid #c4c4c4;
    }

    &:last-child {
      flex: 1 0 auto;
      padding-left: 44px;
      padding-right: 20px;

      h3 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 25px;
      }

      section {
        margin-bottom: 34px;
      }

      .phone {
        font-family: Roboto;
        color: #0072bc;
        display: block;
        font-style: normal;
        font-weight: 300;
        font-size: 22px;
        line-height: 26px;
        letter-spacing: -1px;
      }

      .description {
        font-size: 14px;
        line-height: 26px;
      }

      .space {
        height: 20px;
      }
    }
  }
`;

/**
 * Estilização do componente Backdrop
 */
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1550;
  display: ${({ open }) => (open ? 'block' : 'none')};
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    margin-top: 20px;
    background-color: ${({ color }) =>
      color === 'loading' ? '#ccc !important' : 'inherit'};
  }
`;
